import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Close from '@/icons/Close';
import Sparkles from '@/icons/Sparkles';

import './tone-callout.css';

const STORAGE_PREFIX = 'wetree.memories.toneCallout.dismissed.';

interface ToneCalloutProps {
  firstName: string;
  userId?: string | null;
}

const ToneCallout: React.FC<ToneCalloutProps> = ({ firstName, userId }) => {
  const { t } = useTranslation('screens');
  const { t: tForms } = useTranslation('forms');
  const storageKey = `${STORAGE_PREFIX}${userId ?? 'anonymous'}`;
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(storageKey) === '1');
    } catch {
      setDismissed(false);
    }
  }, [storageKey]);

  if (dismissed) return null;
  const handleDismiss = () => {
    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      // ignore
    }
    setDismissed(true);
  };

  return (
    <div className="tone-callout" role="note">
      <div className="tone-callout__icon" aria-hidden>
        <Sparkles width={16} height={16} />
      </div>
      <div className="tone-callout__content">
        <p className="tone-callout__title">{t('toneCallout.title', { firstName })}</p>
        <p className="tone-callout__body">
          {t('toneCallout.bodyLead')}
          <br />
          <br />
          {t('toneCallout.bodyAudience')}
        </p>
      </div>
      <button
        type="button"
        className="tone-callout__close"
        onClick={handleDismiss}
        aria-label={tForms('actions.dismiss')}
      >
        <Close width={14} height={14} />
      </button>
    </div>
  );
};

export default ToneCallout;
